export interface FactSourceDisplay {
  label: string;
  isExternal: boolean;
}

const normalizeHostForComparison = (host: string): string =>
  host.toLowerCase().replace(/^www\./u, "");

const formatUrlLabel = (url: URL): string => {
  const path = `${url.pathname || "/"}${url.search}${url.hash}`;
  return `${url.host}${path}`;
};

export const formatFactSourceDisplay = (
  sourceUrl: string,
  pageUrl?: string | null,
): FactSourceDisplay => {
  try {
    const source = new URL(sourceUrl);
    let isExternal = false;

    if (pageUrl) {
      try {
        const page = new URL(pageUrl);
        isExternal =
          normalizeHostForComparison(source.hostname) !== normalizeHostForComparison(page.hostname);
      } catch {
        isExternal = false;
      }
    }

    return {
      label: formatUrlLabel(source),
      isExternal,
    };
  } catch {
    return {
      label: sourceUrl,
      isExternal: false,
    };
  }
};
